import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksExpenseFieldsSection', {
    addNewVendor: '+ New Vendor',
    locationField: 'Location',
    departmentPlaceholder: 'Choose {department}',
    payeeFieldTitle: 'Payee',
    payeePlaceholder: 'Choose payee',
    payeeTypeFieldTitle: 'Payee type',
    payeeTypePlaceholder: 'Choose payee type',
    paymentAccountFieldTitle: 'Payment account',
    paymentAccountPlaceholder: 'Choose payment account',
    paymentDateField: 'Payment date',
    paymentDatePlaceholder: 'Enter payment date',
    paymentMethodField: 'Payment method',
    paymentMethodPlaceholder: 'Choose payment method',
    paymentTypeField: 'Payment type',
    paymentTypePlaceholder: 'Choose payment type',
    refNoField: 'Ref no.',
    refNoPlaceholder: 'Enter Ref no.',
    sectionName: 'Details',
    addressLabel: 'Address:',
    emailLabel: 'Email:',
    taxIdLabel: 'TaxId:',
});
